import api from '@/js/services/api';

export default {

    updateAdminInfo(user_id, form) {
        return api().post(`/master-admin/user/profile/update`, form);
    },

    getOnlineUsers() {
        return api().get(`/master-admin/users/online/get`);
    }

}
